"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = void 0;
const _imports_1 = require("./_imports");
const _shared_1 = require("./_shared");
const MethodTypeSchema = _imports_1.z.literal('formula');
const AbstractConfigSchema = _imports_1.z.object({ type: MethodTypeSchema });
const FormulaSchema = AbstractConfigSchema.extend({
    type: _imports_1.z.literal('formula'),
    config: _shared_1.FullFormulaConfigSchema,
});
exports.ConfigSchema = FormulaSchema;
//# sourceMappingURL=CashAdvanceRate.js.map